module.exports = __webpack_public_path__ + "img/go2partners23.f5bed87c.svg";